import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import { router } from './plugins/router';
import { loggedRoutes } from "./plugins/router/logged";
import { allRoutes } from "./plugins/router/allroutes";

import './styles/base.css';
import {jwtDecode} from "jwt-decode";

// Définir le type de payload de votre JWT
type TokenPayload = {
    exp: number;
    // ... autres champs si nécessaire
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const App = () => {
    const [token, setToken] = React.useState<string | null>(localStorage.getItem('token'));
    const [notFound, setNotFound] = React.useState<boolean>(false);

    useEffect(() => {
        // Vérifier si la page est une page "NotFound" ou autre
        if (document.querySelector('.CNotFound') !== null || document.querySelector('#VTarifs') !== null) {
            setNotFound(true);
        }

        // Vérification de l'expiration du token
        if (token) {
            try {
                const decoded = jwtDecode<TokenPayload>(token);
                // Le champ "exp" est en secondes, donc on multiplie par 1000 pour le comparer à Date.now() (en ms)
                if (decoded.exp * 1000 < Date.now()) {
                    // Token expiré : supprimer le token et rediriger vers la page de connexion
                    localStorage.removeItem('token');
                    setToken(null);
                    window.location.href = '/login';
                    return; // Ne pas continuer si le token est expiré
                }
            } catch (error) {
                console.error("Erreur lors du décodage du token", error);
                localStorage.removeItem('token');
                setToken(null);
                window.location.href = '/login';
                return;
            }
        }

        // Logique de redirection selon la route
        if (!['/tarifs', '/tarifs/'].includes(window.location.pathname)) {
            const currentToken = localStorage.getItem('token');
            if (!allRoutes.includes(window.location.pathname)) {
                // Ne rien faire si la route ne fait pas partie des routes autorisées
            } else if (!currentToken && loggedRoutes.includes(window.location.pathname)) {
                window.location.href = '/login';
            } else if (currentToken && !loggedRoutes.includes(window.location.pathname)) {
                window.location.href = '/';
            }
        }
    }, [token]);

    return (
        <div className={`${(!token && !notFound) ? 'dark-bg' : ''}`}>
            <RouterProvider router={router} />
        </div>
    );
}

root.render(
    <App />
);